var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "banner" },
    [
      _c(
        "Carousel",
        _vm._b({ attrs: { autoplay: "" } }, "Carousel", _vm.$attrs, false),
        _vm._l(_vm.bannerList, function(item) {
          return _c(
            "a",
            {
              key: item.ID,
              staticClass: "banner-box",
              attrs: { href: "/detail/" + item.ID }
            },
            [
              _c("img", {
                staticClass: "is_show_block",
                attrs: { src: item.meta_attached_file, alt: "" }
              }),
              _c("img", {
                staticClass: "is_hide_block",
                attrs: { src: item.wpcf_mobile_banner_image, alt: "" }
              }),
              _c("div", { staticClass: "desc" }, [
                _c("p", { staticClass: "img-title" }, [
                  _vm._v(_vm._s(item.wpcf_main_visual_title))
                ]),
                _c("p", { staticClass: "img-desc" }, [
                  _vm._v(_vm._s(item.wpcf_main_visual_sub_title))
                ]),
                item.post_date
                  ? _c("p", { staticClass: "img-date" }, [
                      _vm._v(_vm._s(item.post_date))
                    ])
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/views/components/banner.vue?vue&type=template&id=ac06b1ca&scoped=true&
// module id = 355
// module chunks = 0 2